import styled from "styled-components";
import { theme } from "../../config";

export const SidebarWrapper = styled.div`
  @media ${theme.breakpoints.mobileAndTablet} {
    padding-bottom: 56px;
  }
`;

export const Wrapper = styled.div<{ showHideSidenav: string }>`
  flex-direction: row;
  display: flex;
  height: 100vh;
  @media ${theme.breakpoints.mobileAndTablet} {
    display: block;
    ${(props: any) =>
      props.showHideSidenav === "show" &&
      "background-color: rgba(0, 0, 0, 0.5);transition: 0.5s"}
  }
`;

export const BodyWrapper = styled.div`
  margin-top: 20px;
`;

export const ModalButtonsWrapper = styled.div`
  float: right;
  & #cancel_btn {
    background: ${theme.colors.neutral.black6};
    border: 1px solid ${theme.colors.neutral.black6};
    margin-right: 21px;
  }
`;

export const ButtonWrapper = styled.div`
  width: 140px;
  display: inline-block;
  text-align: center;
`;

export const LogoutContent = styled.p`
  margin: 35px 0 35px;
`;

export const SwitchWrapper = styled.div`
  overflow: hidden;
  height: 100vh;
  width: 100%;
`;
